import { formatPrice, TextPassage } from '@petsmart-ui/sparky';

type CountdownTitleProps = {
    readonly amountAway: number;
    readonly isLoggedIn: boolean;
};

export const CountdownTitle = ({ amountAway, isLoggedIn }: CountdownTitleProps) => {
    if (amountAway === 0) {
        return (
            <TextPassage
                className="countdown-card__title sparky-u-margin-left-xs"
                data-testid="countdown-title"
                role="heading"
                aria-level={3}
            >
                {isLoggedIn ? (
                    <>
                        You're getting <strong>FREE shipping!</strong>
                    </>
                ) : (
                    <>
                        Don't miss out on <strong>FREE shipping!</strong>
                    </>
                )}
            </TextPassage>
        );
    }

    return (
        <TextPassage
            className="countdown-card__title sparky-u-margin-left-xs"
            data-testid="countdown-title"
            role="heading"
            aria-level={3}
        >
            <>
                <strong>{formatPrice(amountAway)}</strong> away from FREE shipping
            </>
        </TextPassage>
    );
};
